// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { doAddFavorite, doDelFavorite } from '../../actions/favorites';
import useMatchRouteContext from '../../hooks/useMatchRouteContext';
import useMergeProps from '../../hooks/useMergeProps';

import MatchHeader from './MatchHeader';
import selectMatchHeaderProps from './MatchHeader.selector';

type MatchHeaderContainerProps = {
  className?: string;
  matchId?: number;
  simplified?: boolean;
  disableScroll?: boolean;
};

const MatchHeaderContainer = ({ matchId: matchIdFromProps, ...ownProps }: MatchHeaderContainerProps) => {
  const dispatch = useDispatch();
  const { matchId: matchIdFromContext } = useMatchRouteContext();
  const matchId = useMemo(() => matchIdFromProps ?? matchIdFromContext, [matchIdFromProps, matchIdFromContext]);

  const selectorProps = useMemo(() => ({ matchId, matchIdFromContext }), [matchId, matchIdFromContext]);
  const selectedProps = useSelector((state) => selectMatchHeaderProps(state, selectorProps));

  const onFavoriteButtonClicked = useCallback(
    (isFavorite: boolean) => {
      if (isFavorite) {
        dispatch(doDelFavorite({ matchId }));
      } else {
        dispatch(doAddFavorite({ matchId }));
      }
    },
    [dispatch, matchId],
  );

  const otherProps = useMemo(() => ({ onFavoriteButtonClicked }), [onFavoriteButtonClicked]);

  const enhancedProps = useMergeProps({
    ownProps,
    selectedProps,
    otherProps,
  });

  return <MatchHeader {...enhancedProps} />;
};

export default MatchHeaderContainer;
